export default "__VITE_ASSET__bf10b8b0__"